import { useEffect, useSyncExternalStore } from 'react';
import { gql } from './api/client';
import { getUserSub } from './auth';

// Whether this person's assessments and policy summaries are canned (mock) or real, paid model calls is stored on
// their Planning profile: set by whoever invites them and changed only by an admin. The server applies it itself;
// this just shows it. A profile with no stored value is mock.
interface MockState { mock: boolean | null; error: string | null }

let state: MockState = { mock: null, error: null };
let loadedFor: string | null = null;
let inFlight: Promise<void> | null = null;
const listeners = new Set<() => void>();

function setState(next: MockState) {
  state = next;
  listeners.forEach(l => l());
}

export function refreshMockMode(): Promise<void> {
  if (inFlight) return inFlight;
  const sub = getUserSub();
  if (!sub) return Promise.resolve();
  inFlight = gql<{ elevationsPlanningUserProfile: { mockMode: boolean | null } | null }>(
    'query MyMockMode($id: ID!) { elevationsPlanningUserProfile(id: $id) { mockMode } }',
    { id: sub },
  )
    .then(d => { loadedFor = sub; setState({ mock: d.elevationsPlanningUserProfile?.mockMode ?? true, error: null }); })
    .catch((e: Error) => setState({ mock: state.mock, error: e.message }))
    .finally(() => { inFlight = null; });
  return inFlight;
}

export function useMockMode(): { mock: boolean | null; error: string | null } {
  const snap = useSyncExternalStore(
    cb => { listeners.add(cb); return () => { listeners.delete(cb); }; },
    () => state,
  );
  useEffect(() => { if (loadedFor !== getUserSub() && !inFlight) void refreshMockMode(); }, []);
  return snap;
}
